import { render } from "./Dashboard.vue?vue&type=template&id=fd008a86&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=fd008a86&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fd008a86"

export default script